import jQuery from 'jquery';
import _ from 'lodash';
import cargarToastr from '@/legacy/umd/cargar_toastr';
import { registerJquery, registerLodash } from '@/legacy/registry';

registerJquery(jQuery);
registerLodash(_);

async function boot() {
  await import('jquery-ujs');
  await import('bootstrap');
  await import('sweetalert');
  // jQuery debe estar en window antes (rama browser del UMD)
  await cargarToastr();
  await import('@/libs/cifra/configure_jquery_ajax');
  await import('@/legacy/login');
}

boot();
